import LazyLoad from "vanilla-lazyload";

const setSlider = () => {

  let slideContainer = document.querySelector('.hero-image');

  if (!slideContainer) return;

  let callback_loaded = function(element) {
    setTransition();
  };

  const lazyLoadInstanceHero = new LazyLoad({
      elements_selector: "[lazy-hero]",
      callback_loaded: callback_loaded
  });    

  function setTransition() {

    let slideImages = slideContainer.querySelectorAll('picture');
    let current = 0;

    setInterval(function() {
      for (var i = 0; i < slideImages.length; i++) {
        slideImages[i].style.opacity = 0;
      }
      current = (current != slideImages.length - 1) ? current + 1 : 0;
      slideImages[current].style.opacity = 1;
    }, 3000);
  }

}

export {setSlider};